import { Route, Routes } from "react-router-dom"
import Login from "../pages/Login"
import DashBoard from "../components/dashboard/DashBoard"
import Profile from "../components/dashboard/Profile"
import ChangePWD from "../components/dashboard/ChangePwd"
import DeliveryReport from "../components/dashboard/DeliveryReport"
import Layout from "../layout/Layout"

import AddOrders from "../components/orders/AddOrders"
import GetOrder from "../components/orders/GetOrder"
import AddAdminStaff from "../components/staffDetails/adminStaff/AddAdminStaff"
import RoleList from "../components/administrator/roles/RoleList"
import RoleAdd from "../components/administrator/roles/RoleAdd"
import RoleChild from '../components/administrator/roles/RoleChild';
import ListAdminStaff from "../components/staffDetails/adminStaff/ListAdminStaff"
import ProtectedRoute from "./ProtectedRoute"
import AddIncentive from "../components/Incentive/AddIncentive"
import ListIncentive from "../components/Incentive/ListIncentive"
import HasPermission from "./HasPermission"
import AddFollowUpUser from "../components/followUpOrder/AddFollowUpUser"
import ListOrders from "../components/orders/ListOrders"
import ReadyToShip from "../components/orders/ReadyToShip"
import Ofd from "../components/orders/Ofd"
import Dlvrd from "../components/orders/Dlvrd"
import Cancelled from "../components/orders/Cancelled"
import FollowUpOrders from "../components/followUpOrder/FollowUpOrders"
import StaffEdit from "../components/staffDetails/adminStaff/StaffEdit"
import AddInquary from "../components/inquary/AddInquiry"
import AddReOrders from "../components/orders/AddReOrders"
import FollowUpReOrders from "../components/followUpOrder/FollowUpReOrders"
import CallingData from "../components/followUpOrder/CallingData"
import PincodeNotsrvs from "../components/orders/PincodeNotsrvs"
import BulkShip from "../components/orders/BulkShip"
import PendingNDR from "../components/ndr/PendingNDR"
import AddProduct from "../components/products/AddProduct"
import ProductList from "../components/products/ProductList"
import AddInventory from "../components/inventory/AddInventory"
import UpdateInventory from "../components/inventory/UpdateInventory"
import Tranjection from "../components/inventory/Tranjection"
import TranHistory from "../components/inventory/TranHistory"
import CustomerDeny from "../components/Punching Response/CustomerDeny"
import Ringing from "../components/Punching Response/Ringing"
import SalePunched from "../components/Punching Response/SalePunched"
import InTransit from "../components/orders/InTransit"
import AssignFollowUpOrder from "../components/followUpOrder/AssignFollowUpOrder"
import SearchOrders from "../components/orders/SearchOrders"
import FollowUpInterested from "../components/followUpOrder/FollowUpInterested"
import AllOrders from "../components/orders/AllOrders"
import EditOrder from "../components/orders/EditOrder"




const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<Login />} />
            {/* Protected Routes */}
            <Route element={<ProtectedRoute />}>
                <Route path="/" element={<Layout />}>
                    {/* DashBoard */}
                    <Route path="/dashboard" element={<DashBoard />} />
                    <Route path="/profile" element={<Profile />} />
                    <Route path="/changepwd" element={<ChangePWD />} />
                    <Route path="/dlreport" element={
                        <HasPermission route="/dlreport"> <DeliveryReport />
                        </HasPermission>
                    } />
                    {/*Administrator */}
                    <Route path="/getrole" element={<RoleList />} />
                    <Route path="/addadminrole" element={<RoleAdd />} />
                    <Route path="/addstaffrole" element={<RoleChild />} />
                    {/*Order */}
                    <Route path="/orderadd" element={<AddOrders />} />
                    <Route path="/orderget" element={<GetOrder />} />

                    <Route path="/adminallorders" element={<ListOrders />} />
                    <Route path="/readytoship" element={<ReadyToShip />} />
                    <Route path="/ofd" element={<Ofd />} />
                    <Route path="/delivered" element={<Dlvrd />} />
                    <Route path="/cancelled" element={<Cancelled />} />
                    <Route path="/reorderadd" element={<AddReOrders />} />
                    <Route path="/pincodensrvcl" element={<PincodeNotsrvs />} />
                    <Route path="/bulkship" element={<BulkShip />} />
                    <Route path="/pending" element={<PendingNDR />} />
                    <Route path="/intransit" element={<InTransit />} />
                    <Route path="/searchorder" element={<SearchOrders />} />
                    <Route path="/orderlist" element={<AllOrders />} />
                    <Route path="/orders/edit/:id" element={<EditOrder />} />

                    {/* User */}
                    <Route path="/staffnew" element={<AddAdminStaff />} />
                    <Route path="/staffList" element={<ListAdminStaff />} />
                    <Route path="/staffEdit/:id" element={<StaffEdit />} />

                    {/* Incentive */}
                    {/* <Route path="/createplan" element={
                      <HasPermission route="/createplan"><AddIncentive />
                      </HasPermission>
                      } /> */}
                    <Route path="/createplan" element={<AddIncentive />} />
                    <Route path="/viewplan" element={<ListIncentive />} />
                    {/* Follow Up Orders */}
                    <Route path="/lstfollowupords" element={<FollowUpOrders />} />
                    <Route path="/lstrefollowupords" element={<FollowUpReOrders />} />
                    {/* FolloUp User */}
                    <Route path="/addfollowupuser" element={<AddFollowUpUser />} />
                    <Route path="/assignFollowUpOrder" element={<AssignFollowUpOrder />} />
                    <Route path="/followup" element={<FollowUpInterested />} />



                    {/* Inquiry Data */}
                    <Route path="/addinquiry" element={<AddInquary />} />
                    <Route path="/callingdata" element={<CallingData />} />

                    {/* Inventory */}
                    <Route path="/addproduct" element={<AddProduct />} />
                    <Route path="/addproduct/:id" element={<AddProduct />} />
                    <Route path="/lstproduct" element={<ProductList />} />
                    <Route path="/addinventory" element={<AddInventory />} />
                    <Route path="/updateinventory" element={<UpdateInventory />} />

                    <Route path="/tranjection" element={<Tranjection />} />
                    <Route path="/tranhis" element={<TranHistory />} />

                    {/* Punching Response */}
                    <Route path="/deny" element={<CustomerDeny />} />
                    <Route path="/ringing" element={<Ringing />} />
                    <Route path="/punch" element={<SalePunched />} />
                </Route>
            </Route>
        </Routes>
    )
}
export default AppRoutes;